import PropTypes from "prop-types";
import { useTheme } from "@emotion/react";
import useBreakpoints from "@util/breakpoints";

const Kicker = ({ children, color, styles, stylesOverride }) => {
  const theme = useTheme();

  const breakCss = useBreakpoints()({
    color: theme.colors.text[color][theme.variant],
    ...theme.typography.kicker,
  });

  return <div css={[breakCss, styles, stylesOverride]}>{children}</div>;
};

Kicker.defaultProps = {
  color: "grey",
  stylesOverride: []
};

Kicker.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    "brand",
    "primary",
    "base",
    "based",
    "grey",
    "secondary",
    "success",
    "error",
    "warning",
    "info",
  ]),
  styles: PropTypes.object,

  stylesOverride: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ])
};

export default Kicker;
